import { render, staticRenderFns } from "./comtitle.vue?vue&type=template&id=2e288d5e&scoped=true&"
import script from "./comtitle.vue?vue&type=script&lang=js&"
export * from "./comtitle.vue?vue&type=script&lang=js&"
import style0 from "./comtitle.vue?vue&type=style&index=0&id=2e288d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e288d5e",
  null
  
)

export default component.exports